@if(hasScore()){
<div
  class="text-blue-o-50 max-sm:hidden font-inter-700 flex-none min-w-[64px] p-1 max-sm:py-[0.7px] text-center rounded-[16px] text-14 max-sm:text-10 bg-red-4"
  [class.text-red-2]="isLiveMatch()"
  [class.font-inter-600]="isLiveMatch()"
>
  {{ match().HomePenaltyScore && homePenaltyScore() }}
  {{ match().HomeScore }}
  -
  {{ match().AwayScore }}
  {{ match().AwayPenaltyScore && awayPenaltyScore() }}
</div>

} @else {
<div
  class="relative max-sm:hidden flex-none w-[50px] max-sm:w-[30px] pl-4 pr-10 font-roboto-500 text-blue text-14 max-sm:text-10 vs-container"
>
  <span class="absolute bg-white content">VS</span>
</div>
}
